// ----------------------------------------------------------------------
// <copyright file="Izenda.DefaultReportPart.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

import React, { Component, PropTypes } from 'react';
import { observer } from 'mobx-react';
import ReportDesignerWidget from 'share/components/hoc/Izenda.ReportDesignerWidget';
import registry from './ReportPartType/Izenda.ReportPartTypeRegistry';
import connect from 'share/enhancers/Izenda.Connect';
import localizer from 'share/localization/Izenda.Localizer';
import ProvisionMapDataStore from 'logic/Izenda.ProvisionMapDataStore';
import { pick } from 'lodash/fp';


const reportTypeButton = props => {
  const rest = pick(['title', 'onClick'], props);
  return (
    <button type="button" className="btn btn-default u_noBorder u_textLeft" {...rest}>
      {props.children}
    </button>
  );
};
const ReportTypeButton = ReportDesignerWidget.wrapper(reportTypeButton);

@connect()
export default class DefaultReportPart extends Component {
  static propTypes = {
    reportPart: PropTypes.object,
    reportBody: PropTypes.object
  };

  render() {
    const props = this.props;

    const reportPart = props.reportPart;
    const reportBody = props.reportBody;

    const buttonLists = registry.REPORT_PART_TYPES.map(item => {
      const hasPrivilege = item.permissions ? props.authorization.checkPrivileges(item.permissions) : true;
      const hasLicense = item.licenseKey ? props.authorization.checkLicense(item.licenseKey) : true;

      return hasPrivilege && hasLicense ? (
        <ReportTypeButton
          key={item.key}
          title={item.label}
          store={props.store}
          onClick={handleSelect.bind(null, item)}
          beforeShowProps={props.beforeShowProps}
          propsEditors={props.propsEditors}
          itemData={reportPart}
        >
          <span className={item.icon} />
          {item.label}
        </ReportTypeButton>
      ) : null;
    });

    return (
      <div className="izenda-TableLayout u-bgWhite u_noMarginTop">
        <div className="u_textRight u_textUppercase u_tableCell u_alignMiddle">
          <div className="u_marginRight">
            <p>{localizer.getText('REPORTDESIGNER_LABEL_TO_CREATE_REPORT_PART')}</p>
            <p>{localizer.getText('REPORTDESIGNER_LABEL_SELECT_A_TYPE')}</p>
          </div>
        </div>
        <div className="u_tableCell u_alignMiddle">
          <div className="u_marginLeft">
            <div className="btn-group-vertical">{buttonLists}</div>
          </div>
        </div>
      </div>
    );

    function handleSelect(item) {
      reportBody.setViewReportPart(reportPart, item);
    }
  }
}



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/Izenda.DefaultReportPart.js